import { REHAB_FORM_TO_PATIENT_DOCUMENT } from "core/consts";
import { AuctionForm, RehabFormName } from "core/types";
import { DownloadSectionWrapper } from "dsl/ecosystems/PatientForms/components";
import { getRehabFormConfig } from "dsl/ecosystems/PatientForms/RehabForms/configs";
import { useCreateRehaPdf } from "dsl/ecosystems/PatientForms/RehabForms/useCreateRehaPdf";
import { getFormInputValue } from "dsl/ecosystems/PatientForms/RehabForms/utils";
import { useDocumentHandling } from "dsl/ecosystems/PatientForms/useDocumentHandling";
import { useTranslations } from "translations";

export const FormDownload = ({
  auctionForms,
  careseekerName,
  externalId,
  formName,
  userId,
}: {
  careseekerName: string;
  externalId: string;
  formName: RehabFormName;
  auctionForms: AuctionForm[] | undefined;
  userId: string;
}) => {
  const translations = useTranslations();
  const { pdfConfig } = getRehabFormConfig(formName);
  const { form, formData } = getFormInputValue({
    auctionForms,
    formName,
  });
  const createRehaPdf = useCreateRehaPdf();
  const { handleOpenPdf, handleSendToHis, progressOpenPdf, progressSendToHis } =
    useDocumentHandling({
      careseekerName,
      createPDFDocument: createRehaPdf,
      externalId,
      userId,
    });

  if (!formData || !form) return null;

  return (
    <DownloadSectionWrapper
      body={translations.patientForms.generalForm.savedFile.description}
      lastUpdated={form.updated_at ?? 0}
      pdfName={pdfConfig.downloadPdfFileName}
      progressOpenPdf={progressOpenPdf}
      progressSendToHis={progressSendToHis}
      title={translations.patientForms.generalForm.savedFile.title}
      onClickPrint={() =>
        handleOpenPdf({
          auctionForms,
          documentNumber: -1,
          externalId,
          formData,
          formName,
        })
      }
      onClickSendToHis={() =>
        handleSendToHis({
          auctionForms,
          documentNumber: -1,
          documentType: REHAB_FORM_TO_PATIENT_DOCUMENT[formName],
          externalId,
          formData,
          formName,
        })
      }
    />
  );
};
